import { init, id } from '@instantdb/react';

export const db = init({
    appId: "954012dc-01f9-4066-a8e7-02547593f0e4",
  })

  